import React, { useContext } from 'react';

import { ServiceResponse } from '../../../app/services/shared/interfaces';
import { toast } from 'react-toastify';

import useReactConfirmAlert from '../../../hooks/useReactConfirmAlert';
import { AppContext } from '../../../contexts/AppContext';
import ActiveControl from '../../../components/ActiveControl';
import useProviderTypeService from '../../../app/services/hooks/useProviderTypeService';

interface Props {
    providerTypeId: number;
    checkValue: boolean;
    callbackSuccess: () => void;
}

const ProviderTypeSwitchChange = ({ providerTypeId, checkValue, callbackSuccess }: Props) => {
    const { showLoading, hideLoading, changeAnimation } = useContext(AppContext);
    const [checked, setChecked] = React.useState<boolean>(checkValue);

    const { activeProviderType, fetchingActiveProviderType } = useProviderTypeService();

    const active = (value: boolean) => {
        setChecked(value);

        activeProviderType(providerTypeId, value, {
            onSuccess: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();

                useReactConfirmAlert().successAlert({
                    title: 'Éxito',
                    message: response.message
                });

                callbackSuccess();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();

                setChecked(!value);
                useReactConfirmAlert().errorAlert({
                    title: 'Error',
                    message: response.message
                });
            }
        });
    };

    return <ActiveControl status={checked} id={providerTypeId} callback={active} />;
};

export default ProviderTypeSwitchChange;
